export const EXPIRATION_TIME_IN_MILLIS = 15 * 60 * 1000
